import React from 'react';
import { motion } from 'framer-motion';
import { FREE_SHIPPING_THRESHOLD } from '../../data/store';
import { formatPrice } from '../../utils/currency';
import { easeOut } from '../../utils/motion';
import { remainingForFreeShipping } from '../../utils/shipping';
export function FreeShippingProgress({
  subtotal
}: {
  subtotal: number;
}) {
  const remaining = remainingForFreeShipping(subtotal);
  const ratio = Math.min(1, subtotal / FREE_SHIPPING_THRESHOLD);
  return <div data-id="element-72" data-mp="1ddt2fqocc5fk">
      <p className="text-sm" data-id="element-73" data-mp="1de2t7gh7mgmb">
        {remaining > 0 ? <>
            Plus que <span className="font-medium" data-id="element-74" data-mp="1dg5rensing24">{formatPrice(remaining)}</span> pour la livraison offerte
          </> : <span className="font-medium text-sage" data-id="element-75" data-mp="14do6ccolktgp">La livraison vous est offerte</span>}
      </p>
      <div className="mt-2 h-1 overflow-hidden rounded-full bg-line" aria-hidden data-id="element-76" data-mp="33qik8uf31fj2">
        <motion.div className={`h-full origin-left rounded-full ${remaining > 0 ? 'bg-clay' : 'bg-sage'}`} initial={false} animate={{
        scaleX: ratio
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} data-id="element-77" data-mp="2yrff79z3r9b3" />
      </div>
    </div>;
}